import React, { Component } from 'react';
import _ from 'lodash';
import { func, string, array } from 'prop-types';
import Table from '../../../../../../components/LazyWidgets/Table';
import EmailWithTooltip from '../../../../../components/EmailTooltip/EmailWithTooltip';
import s from './RevisionPLansNotStartedTable.module.css';
import { withLaunchUrl } from '../../../../hoc/withLaunchUrl';

class RevisionPlansNotStartedTable extends Component {
  static propTypes = {
    data: array,
    courseId: string,
    tableStyle: array,
    sortBy: string,
    onTabChange: func,
    getLaunchUrl: func,
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState.data !== nextProps.data) {
      return ({
        data: nextProps.data,
        tableData: _.sortBy(RevisionPlansNotStartedTable.styleData(nextProps.data), [o => o[prevState.sortBy]]),
        sortBy: prevState.defaultOrder.sortBy,
        direction: prevState.defaultOrder.direction,
      });
    }
    return null;
  }

  static styleData(tData) {
    return tData.map((item) => {
      item.className = 'zeroStyle';
      return item;
    });
  }

  constructor(props) {
    super(props);
    this.tableSort = this.tableSort.bind(this);

    const defaultOrder = {
      sortBy: props.sortBy || 'studentName',
      direction: 'asc',
    };

    this.state = {
      data: this.props.data,
      defaultOrder,
      tableData: _.sortBy(RevisionPlansNotStartedTable.styleData(this.props.data), [o => o[defaultOrder.sortBy]]),
      sortBy: defaultOrder.sortBy,
    };
  }

  miniTableColumns(data) {
    const revisions = _.find(data, ['accessor', 'studentName']);
    const mini = [...data];
    const indexToRemove = mini.indexOf(revisions);
    mini.splice(indexToRemove, 1);
    mini.splice(1, 0, revisions);
    return mini;
  }

  tableSort(e, order) {
    const newTable = _.orderBy(this.state.tableData, [order.column, 'studentName'], [order.direction]);
    this.setState({
      sortBy: order.column,
      direction: order.direction,
      tableData: newTable,
    });
  }

  render() {
    const { tableData } = this.state;

    const tableColumns = [
      {
        accessor: 'studentName',
        Header: 'Name',
        cell: item => (
          <div> <span>{item.studentName}</span> <br />
            <EmailWithTooltip email={item.studentEmail} />
          </div>
        ),
      },
      {
        accessor: 'assignment',
        Header: 'Assignment',
        cell: (item) => {
          const assignment = {
            course_id: this.props.courseId,
            tool: item.tool,
            activity_id: item.activityId,
            id: item.assignmentId,
            tab: 'reports/type/revision-plans-not-started',
          };
          return <a href={this.props.getLaunchUrl(assignment)} >View Assignment</a>;
        },
      },
    ];
    return (
      <Table
        className={s.table}
        data={tableData}
        styling={this.props.tableStyle}
        columns={tableColumns}
        sortable
        ruled
        autosort={false}
        onSortedChange={this.tableSort}
        sortColumn={this.state.sortBy}
        sortDirection={this.state.direction}
        minWidth={200}
      />
    );
  }
}

export default withLaunchUrl(RevisionPlansNotStartedTable);
